import LoadingSpinner from '../UI/LoadingSpinner';

const withLoading = Component => {
    return function WithLoading({ isLoading, ...props }) {
        if (!isLoading) {
            return <Component {...props} />;
        }
        return (
                <LoadingSpinner color="white" height={50} width={50} />
        );
    };
};

export default withLoading;
